import React from 'react';
import classNames from 'classnames';
import s from './index.module.scss';
import { useDesktop } from 'app/hooks/useDesktop';

export const LendingHeader = ({
    header,
    description,
    alignDescription = 'left',
    alignHeader = 'left',
    alignImg = 'center',
    img,
    titleClassname,
    classNameImg = '',
    classNameHeader = '',
    colorHeader,
    colorDescription,
    sizeHeader = '32',
    sizeHeaderMobile = '32',
    sizeDescription = '14',
    sizeDescriptionMobile = '14',
}) => {
    const isDesktop = useDesktop();
    return (
        <div>
            {img && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: alignImg,
                    }}
                    className={classNameImg}
                >
                    <img
                        className={s.img}
                        alt=""
                        src={img}
                        width={'100%'}
                        height={'100%'}
                    />
                </div>
            )}
            <h2
                className={classNames(
                    'lending-section__title',
                    classNameHeader,
                    titleClassname
                )}
                style={{
                    display: 'flex',
                    justifyContent: alignHeader,
                    textAlign: alignHeader,
                    color: colorHeader,
                    fontSize: isDesktop
                        ? `${sizeHeader}px`
                        : `${sizeHeaderMobile}px`,
                }}
            >
                {header}
            </h2>
            <div
                className={'lending-section__extra'}
                style={{
                    display: 'flex',
                    justifyContent: alignDescription,
                    textAlign: alignDescription,
                    color: colorDescription,
                    fontSize: isDesktop
                        ? `${sizeDescription}px`
                        : `${sizeDescriptionMobile}px`,
                }}
            >
                {description}
            </div>
        </div>
    );
};
